var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{ref:"charts",staticStyle:{"width":"700px","height":"625px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }